import { render } from "./MerchantForm.vue?vue&type=template&id=d5986bea&ts=true"
import script from "./MerchantForm.vue?vue&type=script&lang=ts"
export * from "./MerchantForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__